import React from "react";
import Popular from "../Components/UI/Popular";
import Veggie from "../Components/UI/Veggie";

const Home = (props) => {
  return (
    <>
      <Veggie />
      <Popular />
    </>
  );
};

export default Home;
